import ContentLayout from '@/layouts/content-layout'
import RoosterMatchView from '@/sections/rooster-match/view/rooster-match-view'

export default function RoosterMatchPage() {
  return (
    <ContentLayout title="จับคู่แข่งขัน">
      <RoosterMatchView />
    </ContentLayout>
  )
}
